import { motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";
import IndustryCard from "@/components/IndustryCard";
import MetricsBand from "@/components/MetricsBand";
import CTASection from "@/components/CTASection";
import { INDUSTRIES } from "@/data/site";

export default function Industries() {
  return (
    <div data-testid="page-industries">
      <section className="bg-white">
        <div className="sozos-container pt-12 md:pt-16 pb-16">
          <p className="eyebrow">Industries</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#0A1F44] mt-4 tracking-tight leading-[1.02] max-w-4xl">
            Sector-specific revenue playbooks.
          </h1>
          <p className="text-lg md:text-xl text-slate-600 mt-7 max-w-3xl leading-relaxed">
            We don&apos;t run generic outbound. Every program is engineered for the buyers, cycles, and
            economics of your industry — with operators who&apos;ve built revenue inside it.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="sozos-container pb-20">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {INDUSTRIES.map((i, idx) => (
              <IndustryCard key={i.slug} industry={i} index={idx} />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-slate-50 border-y border-slate-200">
        <div className="sozos-container section-pad">
          <SectionHeader
            eyebrow="Industry expertise"
            title="How sector depth changes outcomes."
            description="Every industry has its own ICP language, channel mix, and buying motion. Our playbooks are tuned for each."
          />
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { t: "IT — Products, Services & SaaS", d: "Founder-led to enterprise, PLG to ABM bridges, multi-threaded committee selling across custom dev, managed services, and SaaS." },
              { t: "AI Companies", d: "Category creation, design-partner programs, technical buyer engagement, ROI proof loops." },
              { t: "BFSI", d: "Compliance-friendly outbound, regulator-aware positioning, broker and channel programs across banking, financial services and insurance." },
              { t: "Healthcare", d: "HIPAA-aware messaging, payor/provider personas, conference-led ABM, hospital-system motions." },
              { t: "Manufacturing", d: "Distributor channels, plant manager and ops buyer programs, multi-step procurement nurtures." },
              { t: "Transportation & Logistics", d: "3PL, freight, supply chain, and last-mile — multi-stakeholder selling into ops and finance." },
            ].map((x, i) => (
              <motion.div
                key={x.t}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`industry-detail-${i}`}
                className="bg-white border border-slate-200 rounded-md p-7"
              >
                <h3 className="font-display text-2xl text-[#0A1F44] tracking-tight">{x.t}</h3>
                <p className="text-sm text-slate-600 mt-3 leading-relaxed">{x.d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <MetricsBand />
      <CTASection title="Built for your industry. Engineered for your numbers." subtitle="Talk to a sector specialist" />
    </div>
  );
}
